import { render } from "./TagControl.vue?vue&type=template&id=670bcb1a&scoped=true"
import script from "./TagControl.vue?vue&type=script&lang=js"
export * from "./TagControl.vue?vue&type=script&lang=js"

import "./TagControl.vue?vue&type=style&index=0&id=670bcb1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670bcb1a"]])

export default __exports__